// Lib
import { defaultProps } from '../../../../../node_module_clones/recompose';

// Components
import PointerContainer from './PointerContainer';

export default defaultProps({
    background: 'var(--search-color)',
    color: 'var(--search-color-contrast)',
})(PointerContainer);
